import { render, staticRenderFns } from "./DocumentoVenta_ActualizarPorcentaje.vue?vue&type=template&id=37cbf306&scoped=true"
import script from "./DocumentoVenta_ActualizarPorcentaje.vue?vue&type=script&lang=js"
export * from "./DocumentoVenta_ActualizarPorcentaje.vue?vue&type=script&lang=js"
import style0 from "./DocumentoVenta_ActualizarPorcentaje.vue?vue&type=style&index=0&id=37cbf306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cbf306",
  null
  
)

export default component.exports